/**
 * PC向けのデータベースのヘッダー
 * データベースに関する情報の表示とそれへの操作
 *
 */
import { css } from "@emotion/react";
import { Star, StarOutline } from "@mui/icons-material";
import MenuIcon from "@mui/icons-material/Menu";
import { ButtonGroup, Theme, useTheme } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import { FC } from "react";

import WriteButton from "~/components/database/detail/database-content/database-header/pc/WriteButton";
import { fixedHeight, fixedWidth } from "~/lib/client/design";
import { DatabaseDetailPageProps } from "~/pages/database/[id]";

type Props = {
  openModal: () => void;
  form: DatabaseDetailPageProps["form"];
};

const PcShrunkDatabaseHeader: FC<Props> = ({ openModal, form }) => {
  const theme = useTheme();
  const isStarred = true;

  return (
    <div css={shrunkDatabaseHeaderStyle(theme)}>
      <WriteButton openModal={openModal} height={"3.5rem"} />
      <div css={titleAndActionContainerStyle}>
        <h2 css={titleStyle(theme)}>
          <div>#{form.id}</div>
          <div>{form.title}</div>
        </h2>
        <ButtonGroup sx={buttonGroupStyle}>
          <IconButton>
            {isStarred ? (
              <Star
                sx={{
                  color: theme.palette.primary.main,
                }}
              />
            ) : (
              <StarOutline />
            )}
          </IconButton>
          <IconButton>
            <MenuIcon />
          </IconButton>
        </ButtonGroup>
      </div>
    </div>
  );
};

const shrunkDatabaseHeaderStyle = (theme: Theme) => css`
  position: relative;
  ${fixedHeight("3.5rem")};
  ${fixedWidth("75rem")};
  display: flex;
  flex-direction: row;
  color: ${theme.palette.text.primary};
  background-color: ${theme.palette.background.paper};

  &::before {
    content: "";
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100vw;
    height: 1px;
    background-color: ${theme.palette.divider};
  }
`;

const titleAndActionContainerStyle = css`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  ${fixedHeight("3.5rem")};
  width: 100%;
`;

const titleStyle = (theme: Theme) => css`
  margin: 0 0 0 0.5rem;
  padding: 0;
  font-size: 1.5rem;
  font-weight: 700;
  color: ${theme.palette.text.primary};
  display: flex;
  flex-direction: row;
  align-items: center;
`;

const buttonGroupStyle = {
  display: "flex",
  flexDirection: "row",
  justifyContent: "flex-end",
};

/**
 * @package
 */
export { PcShrunkDatabaseHeader };
